"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Value_value, _Value_hasValue;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = void 0;
/**
 * Wrapper type for a value
 */
class Value {
    constructor() {
        _Value_value.set(this, void 0);
        _Value_hasValue.set(this, false);
    }
    get value() {
        if (!__classPrivateFieldGet(this, _Value_hasValue, "f"))
            throw new Error("Value is not set");
        return __classPrivateFieldGet(this, _Value_value, "f");
    }
    set value(val) {
        __classPrivateFieldSet(this, _Value_value, val, "f");
        __classPrivateFieldSet(this, _Value_hasValue, true, "f");
    }
    /**
     * Indicates if the value has been set at least one time, even if it was a nullish value.
     * @returns {boolean}
     */
    get hasValue() {
        return __classPrivateFieldGet(this, _Value_hasValue, "f");
    }
    valueOf() {
        return this.value;
    }
}
exports.Value = Value;
_Value_value = new WeakMap(), _Value_hasValue = new WeakMap();
//# sourceMappingURL=value.js.map